import type {
  MinigameTurnoverGamePage,
  MinigameTurnoverScopeGame,
} from '~/types/minigame-turnover';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoRequestHeaders } from '~/utils/apostatudo/get-apostatudo-request-headers';

// GET /minigames/turnover-requirements/{id}/games — uma página dos jogos que
// contam para o requisito (ENG-820).
//
// A lista saiu do bloco `turnover_requirement` porque aquele bloco viaja em toda
// carga das telas do jogador, e a curadoria vai até 500 jogos: a maioria, que
// nunca abre a modal, pagava por nomes que não ia ler. Aqui ela é buscada quando
// a modal abre, e de 50 em 50.
//
// Limite do core: 120 req/min, o mesmo orçamento das telas que abrem a modal.
export async function fetchTurnoverGames(
  requirementId: number,
  options: { search?: string; offset?: number; signal?: AbortSignal } = {},
): Promise<MinigameTurnoverGamePage> {
  const query = new URLSearchParams();

  if (options.search) query.set('search', options.search);
  if (options.offset) query.set('offset', String(options.offset));

  const suffix = query.size > 0 ? `?${query.toString()}` : '';

  const response = await fetch(
    `${getApostatudoApiUrl()}/minigames/turnover-requirements/${requirementId}/games${suffix}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        ...getApostatudoRequestHeaders(),
      },
      signal: options.signal,
    },
  );

  if (!response.ok) {
    throw new Error(`Turnover games failed: ${response.status}`);
  }

  const raw = await response.json();

  return {
    games: Array.isArray(raw?.games)
      ? raw.games
          .filter((game: any) => game?.id != null)
          .map(
            (game: any): MinigameTurnoverScopeGame => ({
              id: Number(game.id),
              name: game.name ?? '',
              // Ausente = vazio, nunca `undefined`: a tela decide por "sem link" e "sem
              // capa" a partir de string vazia, e um `/games/undefined` seria um 404.
              slug: game.slug ?? '',
              imageUrl: game.image_url ?? '',
            }),
          )
      : [],
    hasMore: raw?.has_more === true,
    total: raw?.total == null ? null : Number(raw.total),
  };
}
